import React, { useEffect, useState } from "react";
import "./style.css";
import { useDispatch } from "react-redux";
import { Grid, Icon } from "@mui/material";
import { setRouteReducer } from "../../store/actions/routeActions";
import { useNavigate } from "react-router";
import ClientSlider from "./ClientSlider";

export default function Home() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [slideIndex, setSlideIndex] = useState(0);
  const [textSlideIndex, setTextSlideIndex] = useState(0);
  const [clients, setClients] = useState([]);
  const [feedbackSlideStop, setFeedbackSliderStop] = useState(false);

  useEffect(() => {
    getClients();
  }, []);

  const getClients = () => {
    const url = "https://api.textplor.com";
    fetch(url + "/clients", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) =>
        response.json().then((data) => {
          if (response.status === 200) {
            setClients(data?.data || []);
          } else {
            console.error("error in client fetch ", response);
          }
        }),
      )
      .catch((err) => {
        console.error("Error", err);
      });
  };

  useEffect(() => {
    feedbackSlider();
    textSlider();
  }, []);

  useEffect(() => {
    setTimeout(feedbackSlider, 5000); // Change image every 2 seconds
  }, [slideIndex]);

  useEffect(() => {
    setTimeout(textSlider, 3000); // Change image every 2 seconds
  }, [textSlideIndex]);

  const feedbackSlider = () => {
    var i;
    let tempIndex = slideIndex;

    var x = document.getElementsByClassName("w-slide");
    for (i = 0; i < x?.length; i++) {
      if (x && x[i]) {
        x[i].style.display = "none";
      }
    }
    tempIndex++;
    if (tempIndex > x.length) {
      tempIndex = 1;
    }
    if (x && x[tempIndex - 1]) {
      x[tempIndex - 1].style.display = "block";
    }
    setSlideIndex(tempIndex);
  };

  const textSlider = () => {
    var i;
    let tempIndex = textSlideIndex;

    var x = document.getElementsByClassName("primary-text");
    for (i = 0; i < x?.length; i++) {
      if (x && x[i]) {
        x[i].style.display = "none";
      }
    }
    tempIndex++;
    if (tempIndex > x.length) {
      tempIndex = 1;
    }
    if (x && x[tempIndex - 1]) {
      x[tempIndex - 1].style.display = "block";
    }
    setTextSlideIndex(tempIndex);
  };

  const goToLogin = () => {
    dispatch(setRouteReducer({ nextUrl: "/login" }));
    navigate("/login");
  };
  const goToSignUp = () => {
    dispatch(setRouteReducer({ nextUrl: "/signup" }));
    navigate("/signup");
  };

  return (
    <div style={{}}>
      <div
        data-collapse="medium"
        data-animation="default"
        data-duration="400"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        class="navbar-2 navbar-3 w-nav"
      >
        <div class="container-4 w-container">
          <a
            href="/"
            aria-current="page"
            class="brand-2 w-nav-brand w--current"
            style={{ marginLeft: 32 }}
          >
            <img
              height="60"
              src="/docxplor-logo-full.webp"
              alt="Logo of docxPlor"
              // class="image-5 makesmall"
            />
          </a>
          <nav role="navigation" class="nav-menu w-nav-menu">
            <button
              onClick={goToSignUp}
              class="nav-link w-nav-link"
              style={{ marginLeft: 16 }}
            >
              Sign Up
            </button>
          </nav>
          <nav role="navigation" class="nav-menu w-nav-menu">
            <button onClick={goToLogin} class="nav-link w-nav-link">
              Sign In
            </button>
          </nav>
          <div class="menu-button w-nav-button">
            <div class="icon black w-icon-nav-menu"></div>
          </div>
        </div>
      </div>
      <div class="hero-container">
        <div class="section-8">
          <div class="text-container">
            <h1 class="heading-h1">
              Explor your documents <br />
              <span className="primary-text">Easy scan & upload</span>
              <span className="primary-text">Identify type automatically</span>
              <span className="primary-text">Accurate data extraction</span>
              <span className="primary-text">Access from anywhere</span>
              <span className="primary-text">Faster decisions</span>
            </h1>
            <p class="dx-body-black-copy-copy">
              Manual data entry is time-consuming, error-prone, limits
              scalability, and diverts focus from more strategic, value-driven
              tasks. Use docXplor, a cloud platform that automatically
              identifies the type of document and extract all useful information
              <br />
            </p>
            <div class="div-block-5">
              <a
                href="#pricing-head"
                data-w-id="9674c90d-333c-f40f-7f17-937938435dd8"
                class="dx-purple-button w-button"
              >
                Learn more
              </a>
            </div>
          </div>
          <div class="device-container">
            <div class="project-device _1">
              <img
                src="merged.webp"
                height="100%"
                alt="Merged snap shot of docxPlor web and mobile"
                srcset="merged.webp"
              />
            </div>
          </div>
        </div>
      </div>
      <section
        class="section-18 padding-45-bottom grey beige no-padding"
        id="#diff-aspects"
      >
        <div class="container-15 w-container">
          <h2 class="dx-header-caps-bold-black add-padding">
            <strong class="heading-9-copy">
              Multi feature backed Document extraction system
            </strong>
            <br />
          </h2>
        </div>
        <div class="container-16 w-container">
          <div class="columns-2-copy w-row">
            <div class="column w-col w-col-3 w-col-stack">
              <Icon className="feature-icon">cloud_upload</Icon>

              <h3 class="heading-2-copy-copy-2">
                Easy scan & upload
                <br />
              </h3>
              <p class="paragraph-homepage-copy-2">
                Single or zip of documents can be uploaded in web application or
                can be scanned easily with our mobile app.
              </p>
            </div>
            <div class="column-2 bottom w-col w-col-3 w-col-stack">
              <Icon className="feature-icon">list_alt_check</Icon>

              <h3 class="heading-2-copy-copy-2">Accurate data extraction</h3>
              <p class="paragraph-homepage-copy-2">
                Our algorithm can extract data with extremely high accuracy,
                even for handwritten documents.
                <br />
              </p>
            </div>
            <div class="column-2 bottom w-col w-col-3 w-col-stack">
              <Icon className="feature-icon">devices</Icon>

              <h3 class="heading-2-copy-copy-2">Access from anywhere</h3>
              <p class="paragraph-homepage-copy-2">
                documents stored in highly secure cloud platform (AWS) that
                allows accessing files from anywhere
                <br />
              </p>
            </div>
            <div class="column-3 w-col w-col-3 w-col-stack">
              <Icon className="feature-icon">security</Icon>

              <h3 class="heading-2-copy-copy-2">API access</h3>
              <p class="paragraph-homepage-copy-2">
                concerned about data security? No need to store your data in our
                cloud, use docXplor API to process your documents.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div class="div-block-66">
        <div class="w-container">
          <div class="div-block-87 top-padding">
            <h3 class="news-updates-slug no-padding">CASE STUDIES</h3>
          </div>
          <div class="collection-list-wrapper-2 w-dyn-list">
            <div
              role="list"
              class="dx-related-articles-module w-dyn-items w-row"
            >
              <div
                role="listitem"
                class="collection-item-5 w-dyn-item w-col w-col-4"
              >
                <div class="blog-thumbnail-container">
                  <div class="link-block-5 w-inline-block">
                    <img
                      alt="A frustrated man sitting at a table covered with many documents"
                      src="/invoice.jpg"
                      class="image-19"
                    />
                    <div class="paragraph-small-blog">
                      Automate expense management
                    </div>
                    {/* <h4 class="heading-7">Effortless Invoice Processes:</h4> */}
                    <p class="paragraph-small-copy">
                      A top insurance company has an in-house application where
                      employees submit their claims. Employees need to manually
                      fill up an online form and attach relevant receipts
                      related to Local travel (Taxi, Ola, Uber, Rail, Bus,
                      Metro), Food or Restaurant, Hotel stay, Petrol etc.
                      Accounts payable team needs to go through the attachments
                      and verify them. The process is time-consuming, and
                      inefficiencies increase as volumes grow. docXplor
                      automates this expense management process.
                    </p>
                  </div>
                </div>
              </div>
              <div
                role="listitem"
                class="collection-item-5 w-dyn-item w-col w-col-4"
              >
                <div class="blog-thumbnail-container">
                  <div class="link-block-5 w-inline-block">
                    <img
                      alt="Man holding an image showing multiple document types."
                      src="admission.webp"
                      class="image-19"
                    />
                    <div class="paragraph-small-blog">
                      Claim Document Management
                    </div>
                    {/* <h4 class="heading-7">Faster claim processing</h4> */}
                    <p class="paragraph-small-copy">
                      DocXplor helps insurers automate claim processing by
                      extracting and validating data from claim forms, medical
                      records, and policy documents with speed and accuracy. By
                      leveraging AI and machine learning, docXplor reduces
                      manual data entry, identifies discrepancies, and
                      streamlines approvals, leading to faster claim
                      settlements. This not only enhances efficiency but also
                      improves customer satisfaction by reducing processing time
                      and minimizing errors.
                    </p>
                  </div>
                </div>
              </div>
              <div
                role="listitem"
                class="collection-item-5 w-dyn-item w-col w-col-4"
              >
                <div class="blog-thumbnail-container">
                  <div class="link-block-5 w-inline-block">
                    <img
                      alt="A chef reviewing a list of ingredients along with their prices"
                      src="recruitment.webp"
                      class="image-19"
                    />
                    <div class="paragraph-small-blog">Stock Management</div>
                    {/* <h4 class="heading-7">Track raw material consumption</h4> */}
                    <p class="paragraph-small-copy">
                      DocXplor helps restaurants track raw material consumption
                      by automatically extracting and analyzing data from
                      invoices, purchase orders, and inventory records. By
                      digitizing and processing these documents, docXplor
                      provides real-time insights into ingredient usage,
                      minimizes waste, and ensures accurate stock levels. This
                      automation reduces manual errors, enhances cost control,
                      and enables better decision-making for procurement and
                      menu planning
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section
        id="subscribe-form"
        class="personalized-support-module add black"
      >
        <div class="w-container">
          <div class="w-slider">
            <div
              class="w-slider-mask"
              onMouseEnter={() => {
                console.log("feedback Enter");
                setFeedbackSliderStop(true);
              }}
              onMouseLeave={() => {
                console.log("feedback Leave");
                setFeedbackSliderStop(false);
              }}
            >
              <div class="slide w-slide">
                <div class="div-block-82 black">
                  <div class="features-text white">
                    <Icon className="quote-rotate-icon">format_quote</Icon>
                    Our Banking Operations team earlier processed commission
                    invoices manually, which led to delays and requires
                    extensive manual validations for each invoice. Automating
                    this was not easy as every broker uses a different format,
                    and these formats often change — sometimes even with
                    signatures overlapping the numbers. Thanks to Vixplor’s
                    application DocXplor, we have automated the entire workflow.
                    It fetches invoices from email, processes them, extracts key
                    fields (invoice number, date, buyer/seller details, items,
                    rate, price, GST etc.), validates the data, and flags any
                    discrepancies. With over 90% accuracy, it either extracts
                    data correctly or routes the file for manual review,
                    ensuring no invoice is processed with incorrect information.
                    We are very satisfied with the solution.
                    <Icon className="quote-icon">format_quote</Icon>
                  </div>
                  <div class="text-block-10 _20top white">
                    Niteshkumar Bhardwaj, Senior Manager, Magma General
                    Insurance
                  </div>
                </div>
              </div>
              <div class="slide-3 w-slide">
                <div class="div-block-82 black">
                  <div class="features-text white">
                    <Icon className="quote-rotate-icon">format_quote</Icon>
                    We as a system integrator execute various government and
                    corporate projects. Since us mainly deals with data and
                    documents, extraction of data from printed documents is a
                    very common requirement for us. Using docXplor we got
                    excellent success ratio for OCR extraction in various
                    projects. Nevertheless, we must thanks to docXplor for a
                    recent state government project where Birth and Death hand
                    written data (ICR) both in Bengali and English needs to be
                    extracted and deliver in excel. Using docXplor we had
                    finished it for ICR in 70%-75% lesser time line. Thanks to
                    docXplor for providing, value for money. Using the docXplor
                    ICR/OCR platform for extracting data from the Birth and
                    Death Registers has proved helpful in managing large-scale
                    digitization work, especially where we face challenges such
                    as very high document volumes that must be processed within
                    short timelines. All records are handwritten, contain
                    overwriting, and the paper quality is often poor due to age.
                    Despite these difficulties, docXplor has significantly
                    improved accuracy and speed compared to manual entry, and
                    has supported to modernize the record-keeping processes. We
                    appreciate the team’s continuous support and look forward to
                    further accuracy improvements for heavily degraded
                    documents.
                    <Icon className="quote-icon">format_quote</Icon>
                  </div>
                  <div class="text-block-10 _20top white">
                    Tuhin Bhattacharya, Director, GBT Tech Solutions Private
                    Limited
                  </div>
                </div>
              </div>
              <div class="slide-4 w-slide">
                <div class="div-block-82 black">
                  <div class="features-text white">
                    <Icon className="quote-rotate-icon">format_quote</Icon>
                    We have been using the docXplor API since February 2025 to
                    automate data extraction from purchase orders for one of our
                    manufacturing clients. docXplor accurately captures key
                    fields (PO number, date, items, quantity, and delivery
                    address) and processes over 95% of documents end-to-end
                    without human intervention. Initially, a few characters of
                    delivery address were misidentified, but the Vixplor team
                    quickly resolved these issues using advanced NLP techniques.
                    We are very satisfied with the solution.
                    <Icon className="quote-icon">format_quote</Icon>
                  </div>
                  <div class="text-block-10 _20top white">
                    Sanjoy Chatterjee, Director, Entiovi Technologies Private
                    Limited
                  </div>
                </div>
              </div>
            </div>
            <div class="w-slider-arrow-left"></div>
            <div class="w-slider-arrow-right"></div>
            <div class="slide-nav black w-slider-nav w-round"></div>
          </div>
        </div>
      </section>
      <section className=" section-7">
        <Grid container>
          <Grid xs={12} sm={6}>
            <div style={{ padding: 16, textAlign: "justify" }}>
              <h3>Trusted. Certified. Secure.</h3>
              <div className="feature-text ">
                At DocXplor, the confidentiality, integrity, and availability of
                your data are paramount. We are ISO 27001:2022 certified,
                demonstrating our commitment to the highest standards of
                information security management. Our robust security controls,
                secure development practices, and continuous monitoring ensure
                that your documents and data are protected at every stage
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={6}>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <a href="https://www.iafcertsearch.org/certification/URA8UXfMbj3j83c1UMcnvqZb">
                <img width="150px" src="/iaf-logo-medium.webp" alt="IAF logo" />
              </a>
            </div>
          </Grid>
        </Grid>
      </section>
      <section id="subscribe-form grey beige no-padding">
        <div class="row" style={{ margin: 16 }}>
          <div className="col-12 w-col-12 centered">
            <h3 class="text-center col-centered">Clients</h3>
            <ClientSlider clients={clients} />
          </div>
        </div>
      </section>

      {/* <section id="subscribe-form" class="subscribe-form">
        <div class="centered-container-2-copy w-container">
          <p class="paragraph-homepage">
            Ready to streamline your document management efiiciently ?
            <br /> Subscribe and get your documents processed. Also, request our
            team to get your custom documents processed.
          </p>
          <button
            onClick={goToLogin}
            // data-w-id="73c08d6a-5db2-70d6-61a9-15ffaffd0717"
            class="dx-purple-button add-padding w-button"
          >
            Try Now
          </button>
        </div>
      </section> */}
      <div class="info-wrap">
        <div class="footer-4">
          <div class="footer-container">
            <div class="footer-col">
              <h5 class="footer-title">Other Products</h5>
              <a href="/" aria-current="page" class="footer-link-2 w--current">
                Home
              </a>
              <a
                href="https://www.textplor.com"
                class="footer-link-2"
                target="_blank"
                rel="noreferrer"
              >
                Textplor
              </a>
              <a
                href="https://www.vixplor.com"
                class="footer-link-2"
                target="_blank"
                rel="noreferrer"
              >
                Vixplor
              </a>
              <a
                style={{ textDecoration: "none" }}
                href={
                  "https://play.google.com/store/apps/details?id=com.docxplor&pcampaignid=web_share"
                }
              >
                <img
                  style={{ paddingTop: 32 }}
                  width="150px"
                  src="/playstore-logo.svg"
                  alt="Google playstore logo"
                />
              </a>
            </div>

            <div class="footer-col" id="pricing-head">
              <h5 class="footer-title">Legal</h5>
              <a
                href="https://www.vixplor.com/terms-conditions"
                class="footer-link-2"
                target="_blank"
                rel="noreferrer"
              >
                Terms of Service
              </a>
              <a
                href="https://www.vixplor.com/privacy-policy"
                class="footer-link-2"
                target="_blank"
                rel="noreferrer"
              >
                Privacy Policy
              </a>
              <a
                href="/account/delete"
                class="footer-link-2"
                // target="_blank"
                // rel="noreferrer"
              >
                Delete account
              </a>
            </div>
            <div class="footer-col">
              <h5 class="footer-title">ABOUT US</h5>
              <a href="https://www.vixplor.com/contact" class="footer-link-2">
                Contact Us
              </a>
              <a
                href="https://www.google.com/maps/place/NIRALA/@22.561161,88.3684396,17z/data=!3m1!4b1!4m6!3m5!1s0x3a02770015c8d5eb:0x9d6f4b50d338220e!8m2!3d22.561161!4d88.3710145!16s%2Fg%2F11w312472g?hl=en&entry=ttu&g_ep=EgoyMDI2MDYwMS4wIKXMDSoASAFQAw%3D%3D"
                class="footer-link-2"
              >
                Registered Address
                <br /> 2, Canal Street
                <br /> Kolkata 700014
              </a>
              <a href="#" class="footer-link-2">
                Development centre <br /> IIM Calcutta Innovation Park
                <br />
                New Teaching Block, IIM Calcutta, Diamond harbour road, PO.
                Joka, <br />
                Kolkata 700104
              </a>

              <div class="social-wrapper">
                <a
                  href="https://www.youtube.com/@Vixplor"
                  target="_blank"
                  class="icon-2 fb-footer-link _10pd"
                  rel="noreferrer"
                >
                  
                </a>
                <a
                  href="https://www.facebook.com/Vixplor"
                  target="_blank"
                  class="icon-2 fb-footer-link _10pd"
                  rel="noreferrer"
                >
                  
                </a>
                <a
                  href="https://www.linkedin.com/company/vixplor"
                  target="_blank"
                  class="icon-2 fb-footer-link _10pd"
                  rel="noreferrer"
                >
                  
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="div-block-52">
          <div class="footer-container fb-footer">
            <a href="#" class="link-block-2 w-inline-block">
              <h2 class="logo-text l-t-w no-padding-left">DocXplor</h2>
            </a>
            <div class="fb-footer-wrapper">
              <div class="footer-text">
                <div class="text-block-9">
                  © 2025 Vixplor analytics Pvt. Lld.
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div class="cookie-modal"> */}
      {/* <p class="p">
          This website uses cookies.
          <a href="/dms-article/privacy-statement" class="link-10">
            Learn more
          </a>
        </p> */}
      {/* <div data-w-id="b32bf84f-9d18-7764-ae1c-59964ad44840" class="close-btn">
          <div
            style="-webkit-transform:translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(45DEG) skew(0, 0);-moz-transform:translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(45DEG) skew(0, 0);-ms-transform:translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(45DEG) skew(0, 0);transform:translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(45DEG) skew(0, 0)"
            class="line rotate-45"
          ></div>
          <div
            style="-webkit-transform:translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(-45DEG) skew(0, 0);-moz-transform:translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(-45DEG) skew(0, 0);-ms-transform:translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(-45DEG) skew(0, 0);transform:translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(-45DEG) skew(0, 0)"
            class="line rotate-min45"
          ></div>
        </div> */}
      {/* </div> */}
    </div>
  );
}
